import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
//import Auth from './components/hoc/Auth';
import './App.css';

import Cabecalho from './Cabecalho';
import Rodape from './Rodape';
import GuiaInterativo from './GuiaInterativo';

import Inicio from './modules/inicio/Index';
import Admin from './modules/admin/Index';
import Consumo from './modules/consumo/Index';
import AguaMineral from './modules/aguaMineral/Index';
import Contatos from './modules/admin/Contatos';
import Mudancas from './modules/mudancas/Index';
import OutrosAdmin from './modules/admin/OutrosAdmin';
import Notificacao from './modules/notificacao/Index';
import ConfiguracoesNotificacao from './modules/notificacao/Configuracoes';
import Reserva from './modules/reserva/Index';
import RegistroAcesso from './modules/registroAcesso/Index';
import Agenda from './modules/agenda/Index';
import AgendaTarefas from './modules/agenda/AgendaTarefas';
import AgendaTarefasQrCode from './modules/agenda/AgendaTarefasQrCode'
import Problema from './modules/problema/Index';
import Unidade from './modules/unidade/Index';
import AchadosPerdidos from './modules/achados/Index';
import NotFound from './NotFound';

export default class extends Component {
  render() {
    return (
      <div>
        <Cabecalho />
        <Switch>
          <Route exact path="/" component={Inicio} />
          <PrivateRoute roles={['admin', 'sindico', 'conselheiro']} path="/admin/contatos" component={Contatos} />
          <PrivateRoute roles={['admin']} path="/admin/outros" component={OutrosAdmin} />
          <PrivateRoute roles={['admin', 'sindico', 'conselheiro']} path="/admin" component={Admin} />
          <PrivateRoute roles={['admin', 'agua-mineral']} path="/agua-mineral" component={AguaMineral} />
          <PrivateRoute
            roles={[
              'admin',
              'porteiro',
              'sindico',
              'conselheiro',
              'zelador',
              'proprietario',
              'morador',
              'agua-mineral'
            ]}
            path="/notificacoes/configuracoes"
            component={ConfiguracoesNotificacao}
          />
          <PrivateRoute
            roles={[
              'admin',
              'porteiro',
              'sindico',
              'conselheiro',
              'zelador',
              'proprietario',
              'morador',
              'agua-mineral'
            ]}
            path="/notificacoes"
            component={Notificacao}
          />
          <PrivateRoute
            roles={[
              'admin',
              'porteiro',
              'sindico',
              'conselheiro',
              'zelador',
              'proprietario',
              'morador'
            ]}
            path="/reportar-problema"
            component={Problema}
          />
          <PrivateRoute
            roles={[
              'admin',
              'sindico',
              'conselheiro',
              'proprietario',
              'morador',
              'porteiro',
              'zelador'
            ]}
            path="/mudancas"
            component={Mudancas}
          />
          <Route
            roles={[
              'admin',
              'sindico',
              'conselheiro',
              'proprietario',
              'morador',
              'porteiro',
              'zelador'
            ]}
            path="/achados/:id-:title"
            component={AchadosPerdidos}
          />
          <Route
            roles={[
              'admin',
              'sindico',
              'conselheiro',
              'proprietario',
              'morador',
              'porteiro',
              'zelador'
            ]}
            path="/achados"
            component={AchadosPerdidos}
          />
          <PrivateRoute
            roles={[
              'proprietario',
              'morador'
            ]}
            path="/consumo"
            component={Consumo}
          />
          <PrivateRoute
            roles={[
              'morador'
            ]}
            path="/unidade"
            component={Unidade}
          />
          <PrivateRoute
            roles={[
              'admin',
              'sindico',
              'conselheiro',
              'proprietario',
              'morador',
              'porteiro',
              'zelador'
            ]}
            path="/reservas"
            component={Reserva}
          />
          <PrivateRoute
            roles={['admin', 'porteiro', 'sindico', 'conselheiro', 'zelador']}
            path="/registro-acesso"
            component={RegistroAcesso}
          />
          <PrivateRoute
            roles={['admin', 'sindico', 'conselheiro']}
            path="/agenda/tarefas"
            component={AgendaTarefas}
          />
          <PrivateRoute
            roles={['admin', 'sindico', 'conselheiro']}
            path="/agenda/qrcode"
            component={AgendaTarefasQrCode}
          />
          <PrivateRoute
            roles={['admin', 'porteiro', 'sindico', 'conselheiro', 'zelador']}
            path="/agenda"
            component={Agenda}
          />
          <PrivateRoute exact path="/entrar" component={Inicio} />
          <Route component={NotFound} />
        </Switch>
        <Rodape />
        <GuiaInterativo />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AppPage.js